import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  get (limit, offset, isArchived) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}documentType/all?archived=${isArchived}&limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  },
  create (type) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}documentType`, type, AUTH_HEADERS())
  },
  update (type) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}documentType/${type.id}`, type, AUTH_HEADERS())
  },
  archive (id) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}documentType/archive/${id}`, id, AUTH_HEADERS())
  },
  restore (id) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}documentType/restore/${id}`, id, AUTH_HEADERS())
  }
}
